import Writing from './Writing'
export default Writing
